/* 
This script is designed to be used in conjunction with 1 leverJQueryDCI component to generate a table of all open positions.
The positions are linked to other pages, and the links are by convention (rather than set explicitly).
The page ID convention is the kebab case version of the job title. For example, Graphic Designer becomes /graphic-designer.
*/
'use strict';

$(window).on('load', function () {
    var theElement = $('#jobListing');
    var dataProperties = document.getElementById('dataProperties');

    if (theElement.length && dataProperties) {
        $.get(
            dataProperties.dataset.leverApiUrl + '?mode=json',
            function (data) {
                $.each(data, function (index, value) {
                    var listingItem = data[index];

                    var listingTitle = listingItem.text;

                    var relativeUrl =
                        listingTitle
                            .match(
                                /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
                            )
                            .map(function (x) {
                                return x.toLowerCase();
                            })
                            .join('-') + '.html';

                    if (listingTitle == dataProperties.dataset.listingTitle) {
                        return;
                    } else {
                        theElement.append(
                            "<tr class='job-list-item'><td class='jobPosition'><a href=/" +
                            relativeUrl +
                            '> ' +
                            listingTitle +
                            " </a></td><td class='jobTeam'>" +
                            listingItem.categories.team +
                            "</td><td class='jobLocation'>" +
                            listingItem.categories.location +
                            '</td</tr>'
                        );
                    }
                });
            }
        );
    }
});
